<template>
	<div class="details">
		<!-- 比赛结果 -->
		<p class="title-decorate">比赛结果</p>
		<div class="count-list">
			<div v-for="(item,index) in raceDetails.playerList" :key="index" class="row flex between">
				<span>{{index+1}}、{{item.studentName}}</span>
				<span @click="mark(index,0)" :class="{'active':params.users[index].result==0}" class="flex check">胜</span>
				<span @click="mark(index,1)" :class="{'active':params.users[index].result==1}" class="flex check">负</span>
				<span @click="mark(index,2)" :class="{'active':params.users[index].result==2}" class="flex check">未参与</span>
			</div>
		</div>

		<div class="diver"></div>

		<Referee :refereeList="raceDetails.refereeList" />

		<div class="diver"></div>

		<div class="record">
			<p class="title">比赛记录</p>
			<div class="img-list flex start">
				<!-- 限制4张 -->
				<div v-for="(item,index) in params.recordImgs" :key="index" class="img">
					<img @click="delImg(index)" class="delete" src="@img/icon/btn_pic_del.png" alt="">
					<img :src="item" alt />
				</div>

				<div @click="uploadImg" v-if="params.recordImgs.length<4" class="upload flex center">
					<img class="add" src="@img/icon/ui_add.png" alt />
					<span>上传图片</span>
				</div>
			</div>
		</div>

		<div class="btns flex between">
			<button v-if="raceDetails.examineStatus==3" @click="visable=true" class="btn-full">更改结果</button>
			<button v-throttle v-else @click="confirm" class="btn-full">完成</button>
		</div>

		<popup v-model="visable" msg="结果待老师审核<br>审核通过后将不可更改" type="dialogue" title="提示" okText="确认" @confirm="reConfirm" @close="visable=false" />
	</div>
</template>

<script>
import Referee from "@student/course/offlineRace/child/referee.vue";

export default {
	components: {
		Referee,
	},
	data() {
		return {
			visable: false,
			raceDetails: {},
			params: {
				matchId: undefined,
				users: [],
				recordImgs: [],
			},
		};
	},
	mounted() {
		this.params.matchId = this.$route.query.raceId;
		this.getRaceDetails();
	},

	methods: {
		mark(index, type) {
			this.params.users[index].result = type;
		},

		delImg(index){
			let arr = [...this.params.recordImgs];
			arr.splice(index, 1);
			this.params.recordImgs = arr;
		},

		async uploadImg() {
			let uploadInput = document.createElement("INPUT");
			uploadInput.setAttribute("type", "file");
			uploadInput.style.display = "none";
			uploadInput.addEventListener("change", (e) => {
				let files = e.target.files;
				let { size, type } = files[0]; //image/jpeg
				if (size > 2 * 1024 * 1024)
					return this.$message("请上传2MB以内的图片");
				if (
					type != "image/png" &&
					type != "image/jpeg" &&
					type != "image/jpg"
				)
					return this.$message("只能为png、jpg、jpeg格式图片");
				let formData = new FormData();
				formData.append("file", files[0]);
				this.$http
					.post("h5/common/upload", formData)
					.then((res) => {
						if (res.success) {
							this.params.recordImgs.push(res.result.fileUrl);
						}
					})
					.catch((err) => {
						this.$message(err.message);
					});
			});
			uploadInput.click();
		},

		async getRaceDetails() {
			try {
				let { success, message, result } = await this.$http.get(
					`h5/match/viewDetails?matchId=${this.$route.query.raceId}`
				);
				if (!success) throw new Error(message);
				this.raceDetails = result;
				this.raceDetails.playerList.forEach((item) => {
					this.params.users.push({ id: item.id, result: undefined });
				});
			} catch (error) {
				console.log("getRaceDetails", error?.message);
			}
		},
		async confirm() {
			let { users, recordImgs } = this.params;
			for (let i = 0; i < users.length; i++) {
				if (users[i].result === undefined)
					return this.$message("请完善比赛信息");
			}
			try {
				let { success, message } = await this.$http.post(
					"h5/match/matchResult",
					this.params
				);
				if (!success) throw new Error(message);
				this.$message(message);
				this.$router.go(-1);
			} catch (error) {
				this.$message(error?.message);
				console.log("confirm", error?.message);
			}
		},
		async reConfirm() {
			let { users, recordImgs } = this.params;
			for (let i = 0; i < users.length; i++) {
				if (users[i].result === undefined)
					return this.$message("请完善比赛信息");
			}
			try {
				let { success, message } = await this.$http.post(
					"h5/match/updateMatchResult",
					this.params
				);
				if (!success) throw new Error(message);
				this.visable = false;
				this.$message(message);
				this.$router.go(-1);
			} catch (error) {
				this.$message(error?.message);
				console.log("reConfirm", error?.message);
			}
		},
	},
};
</script>


<style lang="less" scoped>
.details {
	padding-bottom: 20 / @rem;
	p.title-decorate {
		padding: 0 17 / @rem;
		font-size: 17 / @rem;
		font-weight: bold;
		&::after {
			content: "";
			display: flex;
			margin-top: 5 / @rem;
			width: 36 / @rem;
			height: 3 / @rem;
			border-radius: 3 / @rem;
			background-color: rgba(255, 162, 22, 1);
		}
	}

	.count-list {
		padding: 0 17 / @rem;
		.row {
			padding: 5 / @rem 0 5 / @rem;
		}
		span {
			font-size: 14 / @rem;
			color: rgba(17, 17, 16, 1);
			margin-right: 20 / @rem;
			&:nth-child(1) {
				flex: 1;
				margin-right: 0;
				font-size: 17 / @rem;
				font-weight: bold;
				color: rgba(31, 30, 29, 1);
			}
			&:last-child {
				margin-right: 0;
			}
			&.check {
				&::before {
					content: "";
					display: flex;
					width: 14 / @rem;
					height: 14 / @rem;
					margin-right: 9 / @rem;
					border-radius: 14 / @rem;
					box-sizing: border-box;
					border: 1 / @rem solid rgba(17, 17, 16, 0.3);
				}
			}
			&.active {
				&::before {
					content: "";
					display: flex;
					width: 14 / @rem;
					height: 14 / @rem;
					border-radius: 14 / @rem;
					background-image: url(~@img/icon/OrangeCircle.png);
					background-repeat: no-repeat;
					background-size: contain;
					border: none;
				}
			}
		}
	}
	.record {
		padding: 0 17 / @rem;
		p.title {
			font-size: 16 / @rem;
			font-family: Source Han Sans CN-Medium;
			font-weight: bold;
			padding: 11 / @rem 0;
		}
		.img-list {
			flex-wrap: wrap;
			.upload,
			.img {
				width: 106 / @rem;
				height: 106 / @rem;
				object-fit: contain;
				border-radius: 7 / @rem;
				margin-right: 11 / @rem;
				margin-bottom: 11 / @rem;
				background-color: rgba(254, 198, 51, 0.2);
				position: relative;
				&:nth-child(3n) {
					margin-right: 0;
				}
				span {
					font-size: 13 / @rem;
					font-family: Source Han Sans CN-Medium;
					color: rgba(255, 162, 22, 1);
					padding-top: 8 / @rem;
				}
				img {
					width: 106 / @rem;
					height: 106 / @rem;
					object-fit: contain;
				}
				img.add {
					width: 40 / @rem;
					height: 40 / @rem;
					object-fit: contain;
					margin: 0;
				}
				img.delete {
				position: absolute;
				display: flex;
				width: 17 / @rem;
				height: 17 / @rem;
				border-radius: 50%;
				right: 6 / @rem;
				top: 6 / @rem;
			}
			}
			
		}
	}

	.btns {
		padding: 0 17 / @rem;
	}
}
</style>
